import { FiltroBandejaCompleto } from "../../features/bandejaMutuos/models/filtroBandeja"
import { controlProps } from "./tablaServer"
import TableFilterComponent from "./tableFilterComponent"
import { TablaBasicFilter } from "../../utils/tableBasicFilter"

interface TableHeaderProps {
    title?: string
    button?: JSX.Element
    control?: controlProps
    buttonExport?: JSX.Element
    searchFilter?: string | null
    setFiltros?: React.Dispatch<React.SetStateAction<TablaBasicFilter>>;
    hideSearchFilter?: boolean | undefined;
}

const TableHeader: React.FC<TableHeaderProps> = ({ title, button, control, buttonExport, searchFilter, setFiltros, hideSearchFilter }) => {
    return (
        <>
            <div className="row" style={{ alignItems: 'center' }}>
                {title &&
                    <div className="col-lg-6 text-start">
                        {title && <div className="col-lg-6"><strong>{title}</strong></div>}
                    </div>
                }
                {control && !hideSearchFilter &&
                    <div className="col-lg-6 text-start" style={{ fontSize: '1.5rem' }}>
                        {control && <div className="col-lg-6"><TableFilterComponent control={control} searchFilter={searchFilter} setFiltros={setFiltros} /></div>}
                    </div>
                }
                {(buttonExport || button) &&
                    <div className="col-lg-6 text-end px-4">
                        {buttonExport && buttonExport}
                        {button && button}                       
                    </div>
                }
            </div>
        </>
    )
}

export default TableHeader
